import React from 'react';
import { VideoIcon, MessageSquareIcon, PlayCircleIcon, UsersIcon } from 'lucide-react';
export function ProgramIntro() {
  return <section className="w-full bg-[#0866FF] text-white py-16 md:py-24" data-id="element-446">
      <div className="max-w-4xl mx-auto px-6" data-id="element-447">
        <div className="text-center mb-12" data-id="element-448">
          <p className="text-blue-200 text-lg mb-4" data-id="element-449">Presentando</p>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4" data-id="element-450">
            META ADS DESDE CERO
          </h2>
          <p className="text-xl md:text-2xl text-blue-100" data-id="element-451">
            Curso en vivo para principiantes que quieren aprender a crear y
            lanzar sus primeras campañas sin volverse locos
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur rounded-2xl p-8 md:p-10 mb-12" data-id="element-452">
          <p className="text-xl mb-8" data-id="element-453">
            Un curso <strong data-id="element-454">100% práctico</strong>, pensado para:
          </p>

          <div className="space-y-6" data-id="element-455">
            <div className="flex gap-4 items-start bg-white/10 rounded-xl p-6" data-id="element-456">
              <UsersIcon className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-457" />
              <p data-id="element-458">
                <strong data-id="element-459">Dueños de negocio</strong> que nunca han hecho anuncios
                pero quieren empezar con el pie derecho.
              </p>
            </div>
            <div className="flex gap-4 items-start bg-white/10 rounded-xl p-6" data-id="element-460">
              <UsersIcon className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-461" />
              <p data-id="element-462">
                <strong data-id="element-463">Freelancers y marketers principiantes</strong> que
                quieren aprender Meta Ads desde la base, sin humo ni atajos
                raros.
              </p>
            </div>
            <div className="flex gap-4 items-start bg-white/10 rounded-xl p-6" data-id="element-464">
              <MessageSquareIcon className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-465" />
              <p data-id="element-466">
                <strong data-id="element-467">Emprendedores que venden por WhatsApp/Instagram</strong>{' '}
                y quieren aprender a traer gente con anuncios, no solo con
                contenido orgánico.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl p-8 md:p-10 mb-10" data-id="element-468">
          <p className="text-xl font-semibold mb-6 text-center" data-id="element-469">
            No es un curso de "ver videos y ya".
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-470">
            Son clases en vivo, donde:
          </p>
          <ul className="space-y-3 text-gray-700" data-id="element-471">
            <li className="flex items-center gap-3" data-id="element-472">
              <VideoIcon className="w-5 h-5 text-[#0866FF] flex-shrink-0" data-id="element-473" />
              Te comparto pantalla.
            </li>
            <li className="flex items-center gap-3" data-id="element-474">
              <PlayCircleIcon className="w-5 h-5 text-[#0866FF] flex-shrink-0" data-id="element-475" />
              Te muestro paso a paso dónde hacer clic.
            </li>
            <li className="flex items-center gap-3" data-id="element-476">
              <MessageSquareIcon className="w-5 h-5 text-[#0866FF] flex-shrink-0" data-id="element-477" />
              Te explico cada concepto con ejemplos simples.
            </li>
            <li className="flex items-center gap-3" data-id="element-478">
              <UsersIcon className="w-5 h-5 text-[#0866FF] flex-shrink-0" data-id="element-479" />
              Respondo tus dudas en directo.
            </li>
          </ul>
        </div>

        <div className="text-center" data-id="element-480">
          <p className="text-xl mb-6" data-id="element-481">Aunque hoy:</p>
          <div className="grid md:grid-cols-3 gap-4 mb-8" data-id="element-482">
            <div className="bg-white/10 rounded-xl p-6" data-id="element-483">
              <p data-id="element-484">No tengas Business Manager.</p>
            </div>
            <div className="bg-white/10 rounded-xl p-6" data-id="element-485">
              <p data-id="element-486">No tengas ni idea de qué es un píxel.</p>
            </div>
            <div className="bg-white/10 rounded-xl p-6" data-id="element-487">
              <p data-id="element-488">Nunca hayas creado una campaña…</p>
            </div>
          </div>
          <p className="text-2xl font-bold" data-id="element-489">
            Este curso está hecho para llevarte de cero a tus primeras campañas
            funcionando.
          </p>
        </div>
      </div>
    </section>;
}